import { createContext } from "react";
import { LinkedinSalesNavigatorFilterInput } from "../__generated__/graphql";
import { gql } from "@apollo/client";

export const AutopilotCuratedLinkedinSalesNavigatorSearchContext_LinkedinSalesNavigatorFilters = gql`
  fragment AutopilotCuratedLinkedinSalesNavigatorSearchContext_LinkedinSalesNavigatorFilters on LinkedinSalesNavigatorFilters {
    jobTitles {
      label
    }
    industries {
      id
      label
    }
    geographies {
      id
      label
    }
    companyHQLocations {
      id
      label
    }
    companyHeadCounts {
      id
      label
    }
    companyNames {
      label
    }
    excludedCompanyNames {
      label
    }
    keywords
  }
`;

const AutopilotCuratedLinkedinSalesNavigatorSearchContext = createContext({
  onSaveFilters: async () => {
    return;
  },
} as {
  onSaveFilters: (value: {
    currentFilters: LinkedinSalesNavigatorFilterInput;
    additionalFiltering: string[];
  }) => Promise<void>;
});

export default AutopilotCuratedLinkedinSalesNavigatorSearchContext;
